var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0642 16.2658H9.44187M0.75 16.6797L5.34366 14.9129C5.63748 14.7999 5.78439 14.7434 5.92183 14.6696C6.04392 14.6041 6.1603 14.5284 6.26977 14.4435C6.39302 14.3478 6.50431 14.2365 6.72691 14.0139L16.0642 4.67664C16.9786 3.76228 16.9786 2.27981 16.0642 1.36546C15.1499 0.451099 13.6674 0.451098 12.7531 1.36545L3.41573 10.7028C3.19314 10.9254 3.08184 11.0367 2.9862 11.1599C2.90125 11.2694 2.82562 11.3858 2.76008 11.5078C2.6863 11.6453 2.6298 11.7922 2.51679 12.086L0.75 16.6797ZM0.75 16.6797L2.4537 12.2501C2.57562 11.9331 2.63657 11.7746 2.74113 11.702C2.8325 11.6386 2.94556 11.6146 3.05483 11.6355C3.17985 11.6593 3.29993 11.7794 3.54007 12.0196L5.41013 13.8896C5.65028 14.1298 5.77035 14.2498 5.79422 14.3749C5.81509 14.4841 5.7911 14.5972 5.72765 14.6886C5.65506 14.7931 5.49657 14.8541 5.17959 14.976L0.75 16.6797Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.9523abbe27027a9ad79c7964475d0f8b.svg";
export { ForwardRef as ReactComponent };